import type { GroupSchemaType, Modification } from '@carboncopyco/types';

export const orderRulesWithGroups = (
  modifications: Modification[],
  groupData: (groupId: string) => Modification<GroupSchemaType.aiPromptGroup>
) => {
  const groups = {} as Record<number, number>;
  return modifications.reduce((acc, modification) => {
    if (modification?.groupId) {
      if (groups.hasOwnProperty(modification.groupId)) {
        acc[groups[modification.groupId]].children.push(modification);
      } else {
        const group = groupData(modification.groupId);
        const hasContent = !!group?.content?.id;
        if (hasContent) {
          groups[modification.groupId] = acc.length;
          acc.push({
            ...group,
            children: [modification],
          });
        } else {
          acc.push(modification);
        }
      }
    } else {
      acc.push(modification);
    }
    return acc;
  }, []);
};
